import { render, staticRenderFns } from "./SDialog.vue?vue&type=template&id=6e78ae1d&scoped=true&"
import script from "./SDialog.vue?vue&type=script&lang=js&"
export * from "./SDialog.vue?vue&type=script&lang=js&"
import style0 from "./SDialog.vue?vue&type=style&index=0&id=6e78ae1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e78ae1d",
  null
  
)

export default component.exports